import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FaqSource } from "../../pages/Communications/utils/types";
import { PmsSourceData } from "../../components/Sources/utils/types";

interface SourcesState {
  faqSources: FaqSource[];
  pmsSources: PmsSourceData | null;
  sourceMessage: string | null;
  sourceLoading: boolean;
  customQaDrawerOpen: boolean;
}

const initialState: SourcesState = {
  faqSources: [],
  pmsSources: null,
  sourceMessage: "No sources available",
  sourceLoading: false,
  customQaDrawerOpen: false,
};

const playgroundSourceSliceV2 = createSlice({
  name: "playgroundSourceV2",
  initialState,
  reducers: {
    setSources: (
      state,
      action: PayloadAction<{
        faqSources: FaqSource[];
        pmsSources: PmsSourceData | null;
      }>
    ) => {
      state.faqSources = action.payload.faqSources;
      state.pmsSources = action.payload.pmsSources;
    },
    setSourceMessage: (state, action: PayloadAction<string>) => {
      state.sourceMessage = action.payload;
    },
    setSourceLoading: (state, action: PayloadAction<boolean>) => {
      state.sourceLoading = action.payload;
    },
    setCustomQaDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.customQaDrawerOpen = action.payload;
    },
    updateSources: (
      state,
      action: PayloadAction<{
        id: string;
        data: Partial<FaqSource>;
      }>
    ) => {
      const { id, data } = action.payload;
      const index = state.faqSources.findIndex((source) => source.id === id);
      if (index !== -1) {
        state.faqSources[index] = {
          ...state.faqSources[index],
          ...data,
        };
      }
    },
    clearSourceMessage: (state) => {
      state.sourceMessage = "No sources available";
    },
    clearSources: (state) => {
      state.faqSources = [];
      state.pmsSources = null;
    },
  },
});

export const {
  setSources,
  setSourceMessage,
  setSourceLoading,
  clearSourceMessage,
  clearSources,
  setCustomQaDrawerOpen,
  updateSources,
} = playgroundSourceSliceV2.actions;

export default playgroundSourceSliceV2;
